/** Единый решатель «какое одно напоминание показать». Чистая логика без React. */
export type NextStep = "safari" | "install" | "push" | "profile" | null;

export type NextStepFacts = {
  inApp: boolean;
  standalone: boolean;
  /** profiles.app_installed_at не пуст */
  installedProfile: boolean;
  /** Есть хотя бы одна подписка на пуши у пользователя (любое устройство). */
  pushAny: boolean;
  /** Подписан ли текущий браузер. */
  pushHere: boolean;
  profileMissing: boolean;
};

export const DEVICE_STEPS: NextStep[] = ["safari", "install", "push"];

export function nextStep(f: NextStepFacts): NextStep {
  const pushAny = f.pushAny || f.pushHere;
  const profile: NextStep = f.profileMissing ? "profile" : null;
  // 1. Всё уже настроено (на любом устройстве) — устройственных шагов нет нигде.
  if (f.installedProfile && pushAny) return profile;
  // 5. Открыто как приложение — считаем установленным.
  const installed = f.installedProfile || f.standalone;
  // 2. Встроенный браузер соцсети без установки.
  if (f.inApp && !installed) return "safari";
  // 3. Не установлено.
  if (!installed) return "install";
  // 4. Установлено, но пушей нет: в приложении — «push», в браузере — облегчённый «install».
  if (!pushAny) return f.standalone ? "push" : "install";
  return profile;
}

/** Облегчённый вариант «install»: приложение уже стоит, нужно открыть его и включить пуши там. */
export function isLightInstall(f: NextStepFacts): boolean {
  return nextStep(f) === "install" && (f.installedProfile || f.standalone);
}

export const DISMISS_DAYS = 3;

/** Карточку, закрытую крестиком, показываем снова не раньше чем через N дней. */
export function shouldShowAfterDismiss(
  dismissedAt: number | null | undefined,
  now: number,
  days = DISMISS_DAYS,
): boolean {
  if (!dismissedAt || !Number.isFinite(dismissedAt)) return true;
  return now - dismissedAt >= days * 24 * 60 * 60 * 1000;
}
